/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M3 14.287c.304.296.715.463 1.144.463h9.712c.429 0 .84-.166 1.144-.463M9 2.25v8.957m0 0l3.7-3.423M9 11.207L5.302 7.784" _stroke="#C09C5E" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
